import React, { useEffect, useState, useRef } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { Form, Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import "./index.css";

const CadPatrimonio = () => {
  const { IDCliente } = useParams();
  const navigate = useNavigate();
  const { objClienteAberto } = usePentagovContext();
  const { authReady } = useAuthContext();
  const { IDOperador, nome } = useOperador();

  const [item, setItens] = useState({});
  const [clienteLogado, setClienteLogado] = useState();
  const [tipoSelecionada, setTipoSelecionada] = useState("todas");
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const [secretariaSelecionada, setSecretariaSelecionada] = useState("todas");

  const [secretarias, setSecretarias] = useState([]);
  const [novaSecretaria, setNovaSecretaria] = useState("");
  const [isNovaSecretaria, setIsNovaSecretaria] = useState(false);

  const pdfRef = useRef(null);

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [formData, setFormData] = useState({
    IDAuditoriapatriminio: null,
    descricao: "",
    tipo: "",
    secretaria: "",
    valoraquisicao: "",
    valoratual: "",
    situacao: "",
    observacao: ""
  });

  useEffect(() => {
    if (authReady && IDOperador) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setClienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {
    try {
      const response = await api.get(`/patrimonio/${IDCliente}`);
      const itens = response.data.Patrimonio || [];

      // Agrupar por tipo
      const agrupados = itens.reduce((acc, curr) => {
        const tipo = curr.tipo || "Outros";
        if (!acc[tipo]) acc[tipo] = [];
        acc[tipo].push(curr);
        return acc;
      }, {});

      setItens(agrupados);

      const itens2 = response.data.Patrimonio || [];

      // pega secretarias únicas
      const secretariasUnicas = [...new Set(itens2.map((i) => i.secretaria).filter(Boolean))];
      setSecretarias(secretariasUnicas);

    } catch (error) {
      console.error("Erro ao buscar patrimônio:", error);
    }
  }

  // Funções CRUD
  const abrirModalInserir = () => {
    setFormData({
      IDAuditoriapatriminio: null,
      descricao: "",
      tipo: "",
      secretaria: "",
      valoraquisicao: "",
      valoratual: "",
      situacao: "",
      observacao: ""
    });
    setIsNovaSecretaria(false);
    setEditando(false);
    setShowModal(true);
  };

  const abrirModalEditar = (pat) => {
    setFormData({
      IDAuditoriapatriminio: pat.IDAuditoriapatriminio,
      descricao: pat.descricao,
      tipo: pat.tipo,
      secretaria: pat.secretaria,
      valoraquisicao: pat.valoraquisicao,
      valoratual: pat.valoratual,
      situacao: pat.situacao,
      observacao: pat.observacao
    });
    setIsNovaSecretaria(false);
    setEditando(true);
    setShowModal(true);
  };

  // salvar (inserir ou editar)
  const handleSalvar = async () => {
    try {
      // Copia do formData para não alterar o original
      const dados = { ...formData };

      Object.keys(dados).forEach((key) => {
        if (
          key !== "tipo" && // não altera o select
          key !== "valoraquisicao" && // não altera número
          key !== "valoratual" &&     // não altera número
          typeof dados[key] === "string" && dados[key].trim() === ""
        ) {
          dados[key] = "-";
        }
      });

      if (editando) {
        await api.put("/patrimonio/"+dados.IDAuditoriapatriminio, { ...dados, IDCliente });
      } else {
        await api.post("/patrimonio", { ...dados, IDCliente });
      }

      setShowModal(false);
      inicializaTela();
    } catch (err) {
        console.error("❌ Erro ao salvar cliente:", err);
        if (err.response) {
          console.error("📩 Erro da API:", {
            status: err.response.status,
            data: err.response.data,
          });

          const bodyErrors = err.response.data?.erros?.body;

          if (bodyErrors) {
            const mensagens = Object.entries(bodyErrors)
              .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
              .join("<br>");

            Swal.fire({
              title: "Erro de validação",
              html: mensagens,
              icon: "error"
            });
          }
        } else {
          alert("Erro inesperado ao salvar cliente. Verifique o console.");
        }
    }
  };


  // deletar
  const handleDeletar = async (pat) => {
    if (window.confirm("Tem certeza que deseja excluir este item?")) {
      try {
        await api.delete(`/patrimonio/${pat.IDAuditoriapatriminio}`);
        inicializaTela();
      } catch (err) {
        console.error("❌ Erro ao salvar cliente:", err);
        if (err.response) {
          console.error("📩 Erro da API:", {
            status: err.response.status,
            data: err.response.data,
          });

          const bodyErrors = err.response.data?.erros?.body;

          if (bodyErrors) {
            const mensagens = Object.entries(bodyErrors)
              .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
              .join("<br>");

            Swal.fire({
              title: "Erro de validação",
              html: mensagens,
              icon: "error"
            });
          }
        } else {
          alert("Erro inesperado ao salvar cliente. Verifique o console.");
        }
      }
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const itensFiltrados = Object.keys(item)
    .filter((categoria) =>
      tipoSelecionada === "todas" ? true : categoria === tipoSelecionada
    )
    .flatMap((tipo) =>
      item[tipo].filter((pat) =>
        secretariaSelecionada === "todas" ? true : pat.secretaria === secretariaSelecionada
      )
    );

  const quantidadeItens = itensFiltrados.length;
  const somaValorAtual = itensFiltrados.reduce((acc, pat) => acc + parseFloat(pat.valoratual || 0), 0);
  const somaValorAquisição = itensFiltrados.reduce((acc, pat) => acc + parseFloat(pat.valoraquisicao || 0), 0);

  const formatarBRL = (valor) => {
    return Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior
          userId={String(IDOperador).padStart(6, "0")}
          userName={nome}
          cliente={clienteLogado}
        />

        <br />
        <h3>Auditoria Patrimonial</h3>

        <Container className="mt-4">
          {/* Filtros */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Select
                value={secretariaSelecionada}
                onChange={(e) => setSecretariaSelecionada(e.target.value)}
              >
                <option value="todas">Todas as Secretarias</option>
                {secretarias.map((sec, idx) => (
                  <option key={idx} value={sec}>
                    {sec}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          
          {/* Botão Novo Item */}
          <div className="text-end mb-3">
            <Button variant="success" onClick={abrirModalInserir}>
              <FaPlus /> Adicionar Item
            </Button>
          </div>

          {/* Lista */}
          {Object.keys(item)
            .filter((categoria) =>
              tipoSelecionada === "todas" ? true : categoria === tipoSelecionada
            )
            .map((tipo, idx) => (
              <div key={idx} className="mb-5">
                <h4 className="mb-3 border-bottom pb-2">{tipo}</h4>

                {item[tipo]
                  .filter((pat) =>
                    secretariaSelecionada === "todas"
                      ? true
                      : pat.secretaria === secretariaSelecionada
                  )
                  .map((pat) => (
                    <Card className="mb-3 shadow-sm" key={pat.ID}>
                      <Card.Body>
                        <Row>
                          <Col md={10}>
                            <Card.Title style={{ fontWeight: "600" }}>{'Descrição:'+ pat.descricao}</Card.Title>
                          </Col>
                          <Col md={2} className="text-end">
                            <Button
                              size="sm"
                              variant="outline-primary"
                              className="me-2"
                              style={{width:'30px'}}
                              onClick={() => abrirModalEditar(pat)}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              style={{width:'30px'}}
                              onClick={() => handleDeletar(pat)}
                            >
                              <FaTrash />
                            </Button>
                          </Col>
                        </Row>
                        <Row className="mb-2" style={{ fontSize: "14px" }}>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Tipo:</strong> {pat.tipo}</Col>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Secretaria:</strong> {pat.secretaria}</Col>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Aquisição:</strong> {formatarBRL(pat.valoraquisicao)}</Col>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Atual:</strong> {formatarBRL(pat.valoratual)}</Col>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Situação:</strong> {pat.situacao || "-"}</Col>
                          <Col md={6} style={{textAlign: 'left'}}><strong>Observação:</strong> {pat.observacao || "-"}</Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
              </div>
            ))}
        </Container>
      </div>

      {/* Modal */}
      <Modal backdrop="static" show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editando ? "Editar Patrimônio" : "Novo Patrimônio"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                name="descricao"
                value={formData.descricao}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Tipo</Form.Label>
              <Form.Select
                name="tipo"
                value={formData.tipo}
                onChange={handleChange}
              >
                <option value="">Selecione um tipo...</option>
                <option value="Imovel">Imóvel</option>
                <option value="Maquinas">Máquinas</option>
                <option value="Moveis">Móveis</option>
                <option value="Veiculo">Veículo</option>
                <option value="Outros">Outros</option>
              </Form.Select>
            </Form.Group>
            
            <Form.Group className="mb-2">
              <Form.Label>Secretaria</Form.Label>
              <Form.Select
                name="secretaria"
                value={formData.secretaria}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "__nova__") {
                    setIsNovaSecretaria(true);
                    setFormData({ ...formData, secretaria: "" });
                  } else {
                    setIsNovaSecretaria(false);
                    setFormData({ ...formData, secretaria: value });
                  }
                }}
              >
                <option value="">Selecione...</option>
                {secretarias.map((sec, idx) => (
                  <option key={idx} value={sec}>{sec}</option>
                ))}
                <option value="__nova__">+ Cadastrar nova</option>
              </Form.Select>

              {/* Campo aparece só quando usuário seleciona "nova" */}
              {isNovaSecretaria && (
                <Form.Control
                  className="mt-2"
                  placeholder="Digite a nova secretaria"
                  value={formData.secretaria}
                  onChange={(e) =>
                    setFormData({ ...formData, secretaria: e.target.value })
                  }
                />
              )}
            </Form.Group>
            
            <Form.Group className="mb-2">
              <Form.Label>Valor Aquisição</Form.Label>
              <Form.Control
                type="number"
                name="valoraquisicao"
                value={formData.valoraquisicao}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Valor Atual</Form.Label>
              <Form.Control
                type="number"
                name="valoratual"
                value={formData.valoratual}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Situação</Form.Label>
              <Form.Control
                name="situacao"
                value={formData.situacao}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Observação</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="observacao"
                value={formData.observacao}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleSalvar}>
            {editando ? "Salvar Alterações" : "Adicionar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CadPatrimonio;
